/**
 * ToolbarButton - reusable toolbar button
 */
export function ToolbarButton({
  title,
  isActive,
  onClick,
  icon,
  children,
  ref,
  className = "",
}) {
  return (
    <button
      ref={ref}
      type="button"
      title={title}
      className={`rte-btn${isActive ? " active" : ""}${className}`}
      onMouseDown={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      {icon && <span className={icon}>{children}</span>}
      {children && !icon && children}
    </button>
  );
}

/**
 * Toolbar divider — the hairline between two groups of tools.
 *
 * `role="separator"` since 2026-08-27: the strip is a `role="toolbar"` now, and a bare `<div>`
 * inside one is an unnamed group of nothing. The role is presentational only in effect — the
 * roving tabindex walks `button`s and skips this — but it is what tells a screen reader the
 * tools either side of it belong to different groups, which is the only thing the hairline
 * has ever said visually.
 */
export function ToolbarDivider() {
  return (
    <div className="rte-divider" role="separator" aria-orientation="vertical" />
  );
}
